import { useState } from "react";

import { faArrowUpRight } from "@fortawesome/pro-regular-svg-icons";
import { useTimeout } from "usehooks-ts";

import { CodeEditor } from "src/base-components/CodeInput/CodeEditor";
import { Button } from "src/design-system/Button";

export type QuerySuggestionType = {
  query: string;
};

type Props = {
  suggestion: QuerySuggestionType;
  onApply: (suggestion: QuerySuggestionType) => void;
  delay?: number;
};

export const QuerySuggestion: React.FC<Props> = ({
  suggestion,
  onApply,
  delay = 0,
}) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <div className="my-4 rounded-lg py-2">
        <div className="space-y-3">
          <div>
            <span className="mt font-inter-normal-12px text-gray-900">
              Suggested SQL Query
            </span>
            <CodeEditor
              dataLoc="copilot-suggested-query"
              language="sql"
              value={suggestion.query}
              lineWrapping
              readOnly
            />
          </div>
        </div>
        <div className="flex justify-end pt-2">
          <Button
            dataLoc="copilot-apply-suggestion"
            iconLeft={faArrowUpRight}
            size="sm"
            variant="secondary"
            onClick={() => onApply(suggestion)}
          >
            Apply changes
          </Button>
        </div>
      </div>
    )
  );
};
